module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/restaurant-icon-61456ca6cd07f45768a82173b796fe2f.png";